import { useContext } from 'react';
import { AppUiContext } from './appUiContext';

export function useAppUi() {
  const ctx = useContext(AppUiContext);
  if (!ctx) {
    throw new Error('useAppUi must be used within AppUiProvider');
  }
  return ctx;
}
